/**
 * A tendency's rank / percentile as a small grey number after its value ("34% 3rd"): no colour, because a share is not
 * good or bad. It replaced the freq needle on every report surface (Trevor, 2026-10-10) and takes the coloured chip's
 * trailing numeral treatment (PercentileChip `.ChipRankNumeral`): three quarters of the value's size, regular weight,
 * the same small lift. Styled inline so a page's own type rules can't resize it (the ownership view sizes every
 * `td .MuiBox-root`).
 */
export default function GreyNumeral({ children }: { children?: React.ReactNode }) {
  if (children === undefined || children === null || children === "") return null;
  return (
    <span
      className="GreyNumeral"
      style={{
        fontSize: "0.75em",
        fontWeight: 400,
        marginLeft: "2.5px",
        position: "relative",
        top: "-1.5px",
        letterSpacing: 0,
        color: "rgba(0, 0, 0, 0.6)",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}
